<template>
	<v-btn rounded outlined :disabled="disabled" color="primary" @click="downloadLabInventory">
		<v-icon class="mr-1">mdi-download</v-icon>
		Lab Inventory ({{ samplingCollectionIds.length }})
	</v-btn>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';
import { useGroups } from '@/store/modules/group';
import { useAllResources } from '@/store/modules/resources';
import { downloadLabInventoryCSV } from './helpers.ts';

export default defineComponent({
	props: {
		samplingCollectionIds: {
			type: Array,
			required: true,
		},
	},
	setup(props, { root }) {
		const { isLoaded: resourcesAreLoaded } = useAllResources(root.$store);
		const { isLoaded: groupsAreLoaded } = useGroups(root.$store);
		const isLoaded = computed(() => resourcesAreLoaded.value && groupsAreLoaded.value);

		const disabled = computed(() => props.samplingCollectionIds.length === 0 || !isLoaded.value);

		function downloadLabInventory() {
			const samplingCollectionsData = props.samplingCollectionIds.map((samplingCollectionId) => {
				const samplingCollection = root.$store.getters['resources/getSamplingCollectionById'](samplingCollectionId);
				return {
					samplingCollectionData: {
						samplingCollection,
						samplings: root.$store.getters['resources/getSamplingsBySamplingCollectionId'](samplingCollectionId),
						samples: root.$store.getters['resources/getSamplesBySamplingCollectionId'](samplingCollectionId),
						locations: root.$store.getters['resources/getLocationsBySamplingCollectionId'](samplingCollectionId),
					},
					includePHandP: root.$store.getters['getIsFieldWithinGroupPath'](
						samplingCollection.featureOfInterest,
						'/soilstack/esmc/'
					),
				};
			});

			downloadLabInventoryCSV(samplingCollectionsData);
		}

		return {
			disabled,
			downloadLabInventory,
		};
	},
});
</script>

<style></style>
